import { render, staticRenderFns } from "./LinkOption.vue?vue&type=template&id=450980cc"
import script from "./LinkOption.vue?vue&type=script&lang=js"
export * from "./LinkOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports